import React from "react";
import { Modal, Alert, Button } from "react-bootstrap";
import { reduxForm, Field } from "redux-form";
import { SimpleField, DropdownListField ,WideField} from "../../common/Inputs";
import * as fetchingState from '../../../constants/fetchingState';
import { connect } from "react-redux";
import { promo as promoType } from '../../../constants/settingTypes';
import { FileInput } from '../../common/FileInput';
import {RichTextEditor} from "../../common/RichTextEditor"

const validate = (values, props) => {
    const errors = {};
    const required = type => {
        if (!values[type] || values[type].length === 0) {
            errors[type] = '*Обязательно для заполнения';
        }
    }

    if(props.isNew && !values.Image){
        errors.Image = '*Обязательно для заполнения';
    }

    required('Name');
    required('Description');
    required('ShareCardSize');
    return errors;
}

class EditModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Image: props.isNew ? null : `api/settings/promo/image/${props.initialValues.Id}?t=${new Date().getTime()}`,
            shareCardSizes: [],
        };
        this._onSubmit = this._onSubmit.bind(this);
    }
    async  componentDidMount() {
            try {
                const response =  await  fetch('/api/settings/promo/card/size');
                const sizes = await  response.json();
                this.setState({ shareCardSizes: sizes });

            } catch (error) {
                console.error("Ошибка загрузки размеров карточек:", error);
            }
        }
        
    _onSubmit(values) {
        this.props.onSubmit(values);
    }

    render() {
        const {
            fetching,
            onClose,
            handleSubmit,
            anyTouched,
            error,
            isNew,
            pristine,
            crudError,
            listData,
        } = this.props;

        const formVisible = fetching === fetchingState.INITIAL;
        const closeButtonVisible = fetching === fetchingState.FETCHED || fetching === fetchingState.FAILED;

        let listNewPosition = []; 
        for(let i=0; i < listData.length; i++)
        listNewPosition.push(listData[i].PositionIndex);
        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{isNew ? 'Новая Акция' : 'Редактирование Акции'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formVisible && (
                        <form className="form-horizontal">
                            <Field name="Name" component={SimpleField} label="Название" />
                            <Field name="Description" component={RichTextEditor} label="Описание"/>
                            <Field name="LinkName" component={SimpleField} label="Название ссылки" />
                            <Field name="Link" component={SimpleField} label="Ссылка" />

                            <Field component={DropdownListField} 
                                data={listNewPosition} 
                                label='Приоритет' 
                                name='PositionIndex'
                                textField='PositionIndex' 
                                valueField= 'PositionIndex'          
                            /> 
                            <Field component={DropdownListField} 
                                data={this.state.shareCardSizes} 
                                label="Размер карточки акции" 
                                name="ShareCardSize"
                                textField="Name" 
                                valueField="Id"
                            />
                            <Field name='IsDisplay' component={WideField} label='Отображать на сайте' type='checkbox' />
                            <Field
                                name="Image"
                                component={FileInput}
                                label="Картинка"
                                accept=".png, .jpg, .jpeg"
                                onChange={(event, newValue, previousValue, name) => {
                                    const file =  newValue;
                                    if (file) {
                                        const image = URL.createObjectURL(file);
                                        this.setState({ Image: image });
                                    }
                                }}
                            />
                            {this.state.Image && <img src={this.state.Image} alt="Загруженное изображение" height="50" />}
                            {anyTouched && error && <strong style={{ color: 'red', marginLeft: '5px' }}>{error}</strong>}
                        </form>
                    )}
                    {fetching === fetchingState.FETCHING && <Alert bsStyle="info">Пожалуйста, подождите...</Alert>}
                    {fetching === fetchingState.FETCHED && <Alert bsStyle="success">УСПЕХ!</Alert>}
                    {fetching === fetchingState.FAILED && (
                        <Alert bsStyle="danger">
                            <p>ОШИБКА!</p>
                            {crudError && <p>{crudError}</p>}
                        </Alert>
                    )}
                </Modal.Body>
                {formVisible && (
                    <Modal.Footer>
                        <Button bsStyle="success" type="submit" onClick={handleSubmit(this._onSubmit)} disabled={pristine}>
                            Сохранить
                        </Button>
                        <Button type="button" onClick={onClose}>
                            Отмена
                        </Button>
                    </Modal.Footer>
                )}
                {closeButtonVisible && (
                    <Modal.Footer>
                        <Button type="button" onClick={onClose}>
                            Закрыть
                        </Button>
                    </Modal.Footer>
                )}
            </Modal>
        );
    }
}

EditModal = reduxForm({
    form: 'promoEdit',
    validate,
})(EditModal);

EditModal = connect((state) => ({
    fetching: state.application.get('settings')[promoType].updateFetching,
    crudError: state.application.get('settings')[promoType].updateError,
}))(EditModal);

export default EditModal;



// WEBPACK FOOTER //
// ./src/components/settings/promo/EditModal.jsx